module.exports = "<div> <div class=\"modal-header\"> <h3 class=\"modal-title\" ng-bind-html=\"vm.title\"></h3> </div> <div class=\"modal-body\"> {{ vm.text }} </div> <div class=\"modal-footer\"> <button class=\"btn btn-primary\" ng-click=\"vm.ok()\">OK</button> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./src/app/core/dialog/okHtmlDialogTemplate.html
// module id = ncnt
// module chunks = 0